export default {
  continent: "continent",
  country: "country",
  city: "city",
  neighborhood: "neighborhood",
  region: "region",
}



// WEBPACK FOOTER //
// ../server/lib/open-planet/placeTypes.js